(function() {
    'use strict';

    angular.module('dashboardApp').service('KeepAlive', Service);

    Service.$inject = [
        'Login',
        'Routing'
    ];


    function Service(
        Login,
        Routing
    ) {




        this.run = function() {
            var delay = 5 * 60 * 1000;

            function repeat() {
                Login.check().then(function(success) {
                    if (success) {
                        $timeout(repeat, delay);
                    } else {
                        Routing.start();
                    }
                });
            }

            repeat();

        };


    }

})();
